export default {
  UPDATE_NOTIFICATION_PREFERENCE: 'UPDATE_NOTIFICATION_PREFERENCE',
  UPDATE_NOTIFICATION_PREFERENCE_SUCCESS: 'UPDATE_NOTIFICATION_PREFERENCE_SUCCESS',
  UPDATE_NOTIFICATION_PREFERENCE_FAILURE: 'UPDATE_NOTIFICATION_PREFERENCE_FAILURE',
};
